export class ModelsVm {
}

export class Product {
  productID?: number;
  categoryID?: number;
  categoryIDFilter?: number;
  productTitle?: string;
  upc?: string;
  vendorItemNumber?: string;
  dupVendorItemNumber?: string;
  parentID?: number;
  parentProduct?: string;
  isActive?: boolean;
  isActiveFilter?: number;
  isVerified?: boolean;
  isVerifiedFilter?: number;
  categoryName?: string;
}

export class Store {
  storeID?: number;
  vendorID?: number;
  vendorName?: string;
  storeNumber?: string;
  dupStoreNumber?: string;
  tdlinx?: string;
  storeName?: string;
  dupStoreName?: string;
  street?: string;
  city?: string;
  state?: string;
  stateCode?: string;
  zip?: string;
  phone?: string;
  isActive?: boolean;
}

export class Category {
  categoryID?: number;
  vendorID?: number;
  categoryName?: string;
  isActive?: boolean;
}

export interface Material {
  materialID?: number;
  materialName?: string;
  materialType?: string;
  dupMaterialType?: string;
  isActive?: boolean;
}

export class ProductUpload {
  DocumentObj: any;
  DocumentName?: string;
  CreatedBy?: number;
  CreatedDate?: Date;
}

export class Adhoc {
  auditType?: string;
  typeOfRequest?: string;
  description?: string;
  responseOptions?: string;
  comments?: string;
  images: any;
  productID?: number;
  imagePath: any;
  notes?: string;
}

export class StoreUpload {
  DocumentObj: any;
  DocumentName?: string;
  CreatedBy?: number;
  CreatedDate?: Date;
}